import React from "react";
import BorderedIconWrapper from "./BorderIconWrapper";
import { Typography } from "@/components/ui/typography";
import FixedIcon from "@/assets/svg/FixedIcon.svg";
import FixedIconDark from "@/assets/svg/FixedIconDark.svg";
import { cn } from "@/lib/utils";
import { TruncatedTextTooltip } from "./TextTooltip";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface FixedCardProps {
  title: string;
  icon: string;
  className?: string;
}

const FixedCard: React.FC<FixedCardProps> = ({ title, icon, className }) => {
  return (
    <div
      className={cn(
        "flex items-center justify-between bg-white dark:bg-blue-700 rounded-lg px-4 border border-grey-200 dark:border-gray-700 shadow-sm",
        "h-[64px] gap-2 min-w-0",
        className
      )}
    >
      {/* Left Side: Icon + Title */}
      <div className="flex items-center gap-3 min-w-0 flex-1">
        <BorderedIconWrapper className="flex-shrink-0">
          <img src={icon} alt={title} className="w-5 h-5 flex-shrink-0" />
        </BorderedIconWrapper>
        <TruncatedTextTooltip text={title} className="min-w-0 flex-1">
          <Typography variant="semibold-16" className="text-grey-800 dark:text-white truncate">
            {title}
          </Typography>
        </TruncatedTextTooltip>
      </div>

      {/* Right Side: Fixed Badge with Tooltip */}
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex items-center justify-center gap-1 w-[63px] h-[24px] bg-grey-200 dark:bg-gray-700 rounded text-xs text-grey-600 dark:text-gray-300 cursor-pointer">
              <img src={FixedIcon} alt="Fixed Info" className="w-[12px] h-[12px] dark:hidden" />
              <img src={FixedIconDark} alt="Fixed Info" className="w-[12px] h-[12px] hidden dark:block" />
              <Typography variant="medium-12" className="text-grey-800 dark:text-gray-300">
                Fixed
              </Typography>
            </div>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            align="end"
            className="max-w-xs bg-gray-700 text-grey-100 break-words z-50 rounded-md px-3 py-1.5"
          >
            <Typography variant="regular-12" className="text-grey-100 italic">
              You can not change the position of this card
            </Typography>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default FixedCard;
